// src/components/MainApp.js
import { useLocation } from 'react-router-dom';  // location情報を取得するフック
import DrawingViewer from '../DrawingViewer';
import ModelViewer from "../ModelViewer";
import ToHomeButton from "../buttons/ToHomeButton";
import NavigateButton from "../buttons/NavigateButton";
import ModelSelecter from "../buttons/ModelSelecter";
import React, { useState, useEffect } from 'react';

function MainApp3() {
  const location = useLocation();
  const errorScore = location.state?.errorScore;  // 渡されたerrorScoreを取得
  const defaultGlbPath = errorScore ? `model${errorScore}` : "model1";
  const [errorGlbPath, setErrorGlbPath] = useState(defaultGlbPath);
  const [motifGlbPath, setMotifGlbPath] = useState(() => (defaultGlbPath && defaultGlbPath.startsWith("cube") ? "cube" : "model"));

  useEffect(() => {
    if (errorGlbPath && errorGlbPath.startsWith("cube")) setMotifGlbPath("cube");
    else setMotifGlbPath("model");
  }, [errorGlbPath]);

  return (
    <div className="page">
      <h1 className="heading-hero mb-6">比較画面</h1>

      <div className="w-full flex flex-row gap-4">
        <div className="w-1/2 flex flex-col items-center">
          <h2 className="heading-lg mb-2">モチーフ</h2>
          <h3 className="text-subtitle mb-1">デッサン</h3>
          <DrawingViewer
            glbPath="model"
            caption="左"
            canvasId="leftDrawingCanvas"
          />
          <h3 className="text-subtitle mt-3 mb-1">3Dモデル</h3>
          <ModelViewer
            glbPath={motifGlbPath}
            imagePath={`./drawing/${motifGlbPath}.png`}
            caption="左"
            canvasId="leftModelCanvas"
          />
        </div>

        <div className="w-1/2 flex flex-col items-center">
          <h2 className="heading-lg mb-2">誤り</h2>
          <h3 className="text-subtitle mb-1">デッサン</h3>
          <DrawingViewer
            glbPath={errorGlbPath}
            caption="右"
            canvasId="rightDrawingCanvas"
          />
          <h3 className="text-subtitle mt-3 mb-1">3Dモデル</h3>
          <ModelViewer
            glbPath={errorGlbPath}
            imagePath={`./drawing/${errorGlbPath}.png`}
            caption="右"
            canvasId="rightModelCanvas"
          />
        </div>
      </div>

      <div className="row-center mt-8">
        <ToHomeButton buttonText="Home画面に戻る" />
        <NavigateButton to="/correction" buttonText="誤りに気が付いた" className="btn--danger" />
        <NavigateButton to="/suggest" buttonText="修正過程を見る" className="btn--secondary" />
        <NavigateButton to="/suggest2" buttonText="修正過程を少しずつ見る" state={{ errorScore }} className="btn--secondary" />
        <ModelSelecter
          errorGlbPath={errorGlbPath}
          setErrorGlbPath={setErrorGlbPath}
        />
      </div>
    </div>
  );
}

export default MainApp3;
